import React from 'react';
import './Hero.css';
import { bannerDesktop } from '../assets/images';

const Hero = ({ onOrderNow }) => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              A bateria do seu carro entregue e instalada em até 50 minutos.
            </h1>
            
            <div className="hero-badge">
              <span className="badge-text">em até 10x</span>
              <span className="badge-subtext">sem juros</span>
            </div>
            
            <div className="hero-ctas">
              <button className="btn-primary btn-large" onClick={onOrderNow}>
                PEÇA AGORA
              </button>
              <button className="btn-secondary btn-large">
                CONFIRA OS PREÇOS
              </button>
            </div>
          </div>
          
          <div className="hero-media">
            <div className="hero-image">
              <img 
                src={bannerDesktop} 
                alt="Técnico instalando bateria automotiva - Entrega rápida"
                className="hero-img img-transparent img-floating"
                onError={(e) => {
                  e.target.src = '/Imagens/1_dobra_desk.jpg';
                }}
              />
              <div className="image-overlay">
                <div className="overlay-badge">
                  <span className="overlay-text">Entrega em até 50min</span>
                </div>
                <div className="overlay-badge-secondary">
                  <span className="overlay-text-secondary">✓ Instalação Gratuita</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Background decoration */}
      <div className="hero-bg-decoration"></div>
    </section>
  );
};

export default Hero;
